var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Savable } from '@/common/mixins/Savable';
import { Focusable } from '@/common/mixins/Focusable';
import { Notification } from "@/common/services/notificationService";
import EntityService from '@/common/services/EntityService';
import { EnumHelpers } from '@/common/mixins/EnumHelpers';
import { RecordState } from '@/common/types/RecordState';
var ContinuousReportBase = /** @class */ (function (_super) {
    __extends(ContinuousReportBase, _super);
    function ContinuousReportBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entityService = new EntityService();
        return _this;
    }
    ContinuousReportBase.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var openPeriods, currentPeriod, sentOrPastDeadlinePeriods;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        openPeriods = this.sectionModel.filter(function (x) { return x.isOpen; });
                        currentPeriod = null;
                        if (openPeriods.length > 0) {
                            currentPeriod = openPeriods[0];
                        }
                        else {
                            sentOrPastDeadlinePeriods = this.sectionModel.filter(function (x) { return x.hasBeenSent || x.pastDeadline; });
                            if (sentOrPastDeadlinePeriods.length > 0) {
                                currentPeriod = sentOrPastDeadlinePeriods[0];
                            }
                        }
                        if (!currentPeriod) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initCurrentPeriod(currentPeriod)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ContinuousReportBase.prototype.initCurrentPeriod = function (currentPeriod) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.handleReadonly(currentPeriod);
                this.currentPeriodId = currentPeriod.continuousReportPeriodId;
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(ContinuousReportBase.prototype, "currentPeriodId", {
        get: function () {
            var period = this.$store.state.vuexPageModule.period;
            return (period !== undefined && period !== null) ? period : null;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_PERIOD", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContinuousReportBase.prototype, "currentMonthId", {
        get: function () {
            var month = this.$store.state.vuexPageModule.month;
            return (month !== undefined && month !== null) ? month : null;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_MONTH", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContinuousReportBase.prototype, "currentSectionPeriodItem", {
        get: function () {
            var _this = this;
            var currentModel = this.currentPeriodId !== null
                ? this.sectionModel.find(function (x) { return x.continuousReportPeriodId == _this.currentPeriodId; })
                : null;
            this.$store.commit("vuexPageModule/SET_CURRENTMODEL", currentModel);
            return currentModel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContinuousReportBase.prototype, "validationErrors", {
        get: function () {
            var temp = this.$route.meta.section;
            if (temp) {
                var sectionNumber = Number(temp);
                return this.$store.getters["vuexPageModule/sectionValidationErrors"](sectionNumber);
            }
            return null;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_VALIDATIONERRORS", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContinuousReportBase.prototype, "currentSection", {
        get: function () {
            return this.$store.state.vuexPageModule.section;
        },
        enumerable: false,
        configurable: true
    });
    ContinuousReportBase.prototype.quarterClass = function (periodId) {
        var _this = this;
        var period = this.sectionModel.find(function (x) { return x.continuousReportPeriodId == periodId; });
        var cssClass = "quarter relative";
        if (period.isOpen) {
            cssClass += " open";
            var relevantValidationErrors = this.validationErrors.filter(function (x) { return x.groupId == _this.currentSection && x.periodId == periodId; });
            if (relevantValidationErrors.length > 0) {
                cssClass += " validation-errors";
            }
        }
        else if (period.hasBeenSent || period.pastDeadline) {
            cssClass += " sent";
        }
        if (periodId == this.currentPeriodId) {
            cssClass += " selected";
        }
        return cssClass;
    };
    ContinuousReportBase.prototype.monthClass = function (periodId, monthId) {
        var _this = this;
        var cssClass = "month relative";
        var relevantValidationErrors = this.validationErrors.filter(function (x) { return x.groupId == _this.currentSection && x.periodId == periodId && x.monthId == monthId; });
        if (relevantValidationErrors.length > 0) {
            cssClass += " validation-errors";
        }
        return cssClass;
    };
    Object.defineProperty(ContinuousReportBase.prototype, "recordableHasBeenStarted", {
        get: function () {
            var recordable = this.$store.state.vuexPageModule.recordable;
            return recordable
                && recordable.record != undefined
                && recordable.record.state == RecordState.OpenInWeb;
        },
        enumerable: false,
        configurable: true
    });
    ContinuousReportBase.prototype.navigateToQuarter = function (periodId) {
        return __awaiter(this, void 0, void 0, function () {
            var period;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        period = this.sectionModel.find(function (x) { return x.continuousReportPeriodId == periodId; });
                        return [4 /*yield*/, this.handleReadonly(period)];
                    case 1:
                        _a.sent();
                        if (!(period.hasBeenSent || period.isOpen || period.pastDeadline)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.waitUntilSaved()];
                    case 2:
                        _a.sent();
                        // This bit works around the issue where the model changes in response to the currentPeriodId
                        // value changing, and this in turn triggers watches which cause the model to change.
                        this.currentPeriodId = null;
                        return [4 /*yield*/, this.$nextTick()];
                    case 3:
                        _a.sent();
                        this.currentPeriodId = periodId;
                        if (!(this.recordableHasBeenStarted && period.isOpen)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.validate()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ContinuousReportBase.prototype.navigateToMonth = function (periodId, month) {
        return __awaiter(this, void 0, void 0, function () {
            var period;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        period = this.sectionModel.find(function (x) { return x.continuousReportPeriodId == periodId; });
                        return [4 /*yield*/, this.handleReadonly(period)];
                    case 1:
                        _a.sent();
                        if (!(period.hasBeenSent || period.isOpen || period.pastDeadline)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.waitUntilSaved()];
                    case 2:
                        _a.sent();
                        // This bit works around the issue where the model changes in response to the currentPeriodId
                        // value changing, and this in turn triggers watches which cause the model to change.
                        this.currentPeriodId = null;
                        this.currentMonthId = null;
                        return [4 /*yield*/, this.$nextTick()];
                    case 3:
                        _a.sent();
                        this.currentPeriodId = periodId;
                        this.currentMonthId = month;
                        if (!(this.recordableHasBeenStarted && period.isOpen)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.validate()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ContinuousReportBase.prototype.handleReadonly = function (period) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!period.hasBeenSent) return [3 /*break*/, 2];
                        this.$store.commit("vuexPageModule/SET_CUSTOMREADONLY", true);
                        return [4 /*yield*/, this.$store.dispatch("vuexPageModule/setPreventSending", "ContinuousReport.QuarterHasBeenSent")];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!period.pastDeadline) return [3 /*break*/, 4];
                        this.$store.commit("vuexPageModule/SET_CUSTOMREADONLY", true);
                        return [4 /*yield*/, this.$store.dispatch("vuexPageModule/setPreventSending", "ContinuousReport.QuarterPastDeadline")];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!period.isOpen) return [3 /*break*/, 6];
                        this.$store.commit("vuexPageModule/SET_CUSTOMREADONLY", false);
                        return [4 /*yield*/, this.$store.dispatch("vuexPageModule/clearPreventSending")];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ContinuousReportBase.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var errors, e_1, notification;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.entityService.validationErrors("ContinuousReport", this.sectionModel[0].continuousReportId)];
                    case 1:
                        errors = _a.sent();
                        // refresh vee-validate validation messages
                        this.validationObserver.validate();
                        // set validationErrors from the back-end
                        this.validationErrors = errors;
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        notification = this.$t("Entities.UnexpectedValidationError");
                        Notification.error(this, notification);
                        this.validationErrors = [];
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ContinuousReportBase.prototype, "validationObserver", {
        get: function () {
            // Find the ValidationObserver by walking up the component tree
            var temp = this;
            var obs = temp.$refs["observer"];
            while (obs == undefined && temp.$parent != undefined) {
                temp = temp.$parent;
                obs = temp.$refs["observer"];
            }
            return obs;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: String, required: true }),
        __metadata("design:type", String)
    ], ContinuousReportBase.prototype, "recordId", void 0);
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], ContinuousReportBase.prototype, "sectionModel", void 0);
    __decorate([
        Prop({ type: Array, required: true }),
        __metadata("design:type", Array)
    ], ContinuousReportBase.prototype, "targetGroupOptions", void 0);
    ContinuousReportBase = __decorate([
        Component({
            name: "ContinuousReportBase"
        })
    ], ContinuousReportBase);
    return ContinuousReportBase;
}(Mixins(Focusable, Savable, EnumHelpers)));
export default ContinuousReportBase;
